mutation UpdateChatOverlay(
  $chatId: ID!
  $name: String
  $twitchChatChannels: [String!]
  $textShadow: String
  $showBadges: Boolean
  $showChannelPills: Boolean
  $usernameFontSize: Int
  $usernameLineHeight: Int
  $messageFontSize: Int
  $messageLineHeight: Int
  $messageFontWeight: Int
  $usernameFontWeight: Int
  $imageScale: Int
  $messageColor: String
  $blockedWords: [String!]
  $fontFamily: String
  $youtubeChatChannels: [String!]
  $chatDelayMs: Int
  $width: Int
  $height: Int
  $show7tvEmotes: Boolean
  $showBttvEmotes: Boolean
  $showFfzEmotes: Boolean
  $showYouTubeProfilePictures: Boolean
) {
  chat: StreamToolsUpdateChatOverlay(
    chatId: $chatId
    name: $name
    twitchChatChannels: $twitchChatChannels
    textShadow: $textShadow
    showBadges: $showBadges
    showChannelPills: $showChannelPills
    usernameFontSize: $usernameFontSize
    usernameLineHeight: $usernameLineHeight
    messageFontSize: $messageFontSize
    messageLineHeight: $messageLineHeight
    messageFontWeight: $messageFontWeight
    usernameFontWeight: $usernameFontWeight
    imageScale: $imageScale
    messageColor: $messageColor
    blockedWords: $blockedWords
    fontFamily: $fontFamily
    youtubeChatChannels: $youtubeChatChannels
    chatDelayMs: $chatDelayMs
    width: $width
    height: $height
    show7tvEmotes: $show7tvEmotes
    showBttvEmotes: $showBttvEmotes
    showFfzEmotes: $showFfzEmotes
    showYouTubeProfilePictures: $showYouTubeProfilePictures
  ) {
    chatId
    name
    twitchChatChannels
    showTextShadow
    textShadow
    showBadges
    showChannelPills
    usernameFontSize
    usernameLineHeight
    messageFontSize
    messageLineHeight
    messageFontWeight
    usernameFontWeight
    imageScale
    messageColor
    blockedWords
    fontFamily
    youtubeSourceEnabled
    youtubeChatChannels
    chatDelayMs
    width
    height
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    showYouTubeProfilePictures
    createdAt
  }
}
